import { ActionType, createAsyncAction } from "typesafe-actions";

import CoachingNoteCategory from "@app/scene/dashboard/types/CoachingNoteCategory";

export const fetchCoachingNoteCategories = createAsyncAction(
  "@dashboard/coaching/categories/fetch/request",
  "@dashboard/coaching/categories/fetch/success",
  "@dashboard/coaching/categories/fetch/failure"
)<void, CoachingNoteCategory[], void>();

export const createCoachingNoteCategory = createAsyncAction(
  "@dashboard/coaching/categories/create/request",
  "@dashboard/coaching/categories/create/success",
  "@dashboard/coaching/categories/create/failure"
)<{ name: string }, CoachingNoteCategory, void>();

export const updateCoachingNoteCategory = createAsyncAction(
  "@dashboard/coaching/categories/update/request",
  "@dashboard/coaching/categories/update/success",
  "@dashboard/coaching/categories/update/failure"
)<
  { callback?: () => void; categoryId: CoachingNoteCategory["id"] } & Partial<
    Pick<CoachingNoteCategory, "name" | "prompts">
  >,
  CoachingNoteCategory,
  void
>();

export const deleteCoachingNoteCategory = createAsyncAction(
  "@dashboard/coaching/categories/delete/request",
  "@dashboard/coaching/categories/delete/success",
  "@dashboard/coaching/categories/delete/failure"
)<
  { categoryId: CoachingNoteCategory["id"] },
  { categoryId: CoachingNoteCategory["id"] },
  { categoryId: CoachingNoteCategory["id"] }
>();

export const reorderCoachingNoteCategories = createAsyncAction(
  "@dashboard/coaching/categories/reorder/request",
  "@dashboard/coaching/categories/reorder/success",
  "@dashboard/coaching/categories/reorder/failure"
)<{ orderedIds: Array<CoachingNoteCategory["id"]> }, CoachingNoteCategory[], void>();

export type CoachingNoteCategoriesActions = ActionType<
  | typeof createCoachingNoteCategory
  | typeof deleteCoachingNoteCategory
  | typeof fetchCoachingNoteCategories
  | typeof reorderCoachingNoteCategories
  | typeof updateCoachingNoteCategory
>;
